import * as React from "react";
import IconWrapper from "../../../hiberUiKit/src/atoms/Icon/IconWrapper";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import IconLarge from "../../../hiberUiKit/src/atoms/Icon/IconLarge";
import Routes from "../../../navigation/route/Route";
import {RouteComponentProps, RouteProps, withRouter} from "react-router";
import ButtonSecondary from "../../../hiberUiKit/src/atoms/Buttons/ButtonSecondary";
import Job from "../../../model/job/Job";
import ConfirmRemoveOrderModal from "./ConfirmRemoveOrderModal";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {Option} from "ts-option";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import {cancelBillOfMaterials} from "../../../store/action/billOfMaterials/billOfMaterials";
import {OnFailure, OnSuccess} from "../../../store/action/actionHelpers";
import "../../accounting/common/commonDetailsStatusRow.scss";

interface IProps {
	/**
	 * Job object
	 */
	job: Job;
	/**
	 * Action when data refresh is necessity
	 */
	onDataRefreshNecessity: () => void;
	/**
	 * Bom identifier
	 */
	bomId: Option<string>;
	/**
	 * If false, bom is read only.
	 */
	editable: boolean;
}

interface DispatchProps {
	/**
	 * Cancel Bom
	 */
	cancelBillOfMaterials: (bomId: string, jobId: string, onSuccess: OnSuccess, onFailure: OnFailure) => void
}

interface State {
	/**
	 * Indicates if remove confirmation modal is visible.
	 */
	removeOrderConfirmationVisible: boolean
}

type Props = IProps & DispatchProps & RouteComponentProps<RouteProps>;

class JobBillOfMaterialsHeader extends React.PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			removeOrderConfirmationVisible: false
		};
	}

	render() {
		return (
			<div className="c-common-status">
				<div className="c-common-status_ref-nums-container">
					<div style={{display: "inline"}}>
						<div className="c-common-status_lead-ref-num is-clickable" onClick={this.redirectToJob}>
							Job ID# {this.props.job.referenceNumber}
						</div>
						<div className="c-common-status_ref-num-arrow">
							<IconWrapper variant={"lighterBlue"} icon={Icon.ArrowRight} size={11}/>
						</div>
					</div>
					<div className="c-common-status_quote-ref-num">Merchants</div>
				</div>
				<div className="c-common-status_row-container">
					<div className="c-common-status_back-button-container" onClick={this.props.history.goBack}>
						<IconLarge variant={"burgundy"} icon={Icon.ArrowLeft}/>
					</div>
					<div className="c-common-status_quote-icon-container">
						<IconWrapper icon={Icon.Parts} viewBoxFromSize={true} size={21}/>
					</div>
					<div className="c-common-status_quote-text">
						Merchants for ID# {this.props.job.referenceNumber}
					</div>
					{this.props.editable && this.props.bomId.map(() => (
						<div className="job-bill-of-materials_buttons-container">
							<ButtonSecondary label={"Cancel selection"}
											 onClick={() => this.setState({removeOrderConfirmationVisible: true})}/>
						</div>
					)).orNull}
				</div>
				{this.state.removeOrderConfirmationVisible &&
				<ConfirmRemoveOrderModal
					onClose={() => this.setState({removeOrderConfirmationVisible: false})}
					onConfirm={this.removeOrder}/>}
			</div>
		);
	}

	redirectToJob = () => this.props.history.push(Routes.EditJob(this.props.job.referenceNumber));

	removeOrder = () => {
		this.props.bomId.map(bomId => {
			this.props.cancelBillOfMaterials(bomId, this.props.job.id,
				() => {
					this.setState({removeOrderConfirmationVisible: false});
					this.props.onDataRefreshNecessity();
				},
				(error) => {
					notifyBugsnagAndShowToast(error, "Cancel selection of merchant for ordering");
				});
		});
	};
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		cancelBillOfMaterials: (bomId: string,
			jobId: string,
			onSuccess: OnSuccess,
			onFailure: OnFailure) => dispatch(
			cancelBillOfMaterials(bomId, jobId, onSuccess, onFailure)
		)
	}
}

export default withRouter<IProps>(connect(null, mapDispatchToProps)(JobBillOfMaterialsHeader));
